import { initLazySizes } from '@xsite-ui/common.image/lazy';
import { initCookiePolicyScript } from '@xsite-ui/gaming.cookie-banner/client-script';
import { initFooterScripts } from '@xsite-ui/gaming.gaming-footer/client-script';

(() => {
  initLazySizes();
  initCookiePolicyScript();
  initFooterScripts();
})();

export {};
